import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "trigger__icon icon--left"
}
const _hoisted_2 = { class: "trigger__main" }
const _hoisted_3 = {
  key: 0,
  class: "main__value"
}
const _hoisted_4 = {
  key: 1,
  class: "main__value"
}
const _hoisted_5 = {
  key: 2,
  class: "main__placeholder"
}
const _hoisted_6 = { class: "trigger__icon icon--right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", { d: "m6 9 6 6 6-6" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "bs-select__validation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_loader = _resolveComponent("bs-loader")!
  const _component_bs_field = _resolveComponent("bs-field")!
  const _component_options = _resolveComponent("options")!
  const _component_bs_dropdown_tooltip = _resolveComponent("bs-dropdown-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-select bs-select--icon-right", {
            'bs-select--disabled': _ctx.disabled,
            'bs-select--invalid': _ctx.invalid,
            'bs-select--loading': _ctx.loading,
            'bs-select--medium': _ctx.size === 'medium',
            'bs-select--big': _ctx.size === 'big',
            'bs-select--opened': _ctx.isVisible,
            'bs-select--icon-left': Boolean(_ctx.$slots['icon-left']),
        }]),
    ref: "containerReference"
  }, [
    _createElementVNode("div", {
      class: "bs-select__trigger",
      ref: "reference",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOptions && _ctx.toggleOptions(...args)))
    }, [
      (_ctx.$slots['icon-left'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "icon-left")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (Array.isArray(_ctx.modelValue) && (_ctx.modelValue as Array<string | number>).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              ((_ctx.modelValue as Array<string | number>).length === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.selectedOption)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Выбрано: " + _toDisplayString(_ctx.selectedOption[_ctx.displayBy]), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Выбрано неизвестное значение")
                        ], 64))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Выбрано: " + _toDisplayString((_ctx.modelValue as Array<string | number>).length), 1)
                  ], 64))
            ]))
          : (!Array.isArray(_ctx.modelValue) && Boolean(_ctx.modelValue))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.$slots['selected-option'])
                  ? _renderSlot(_ctx.$slots, "selected-option", { key: 0 })
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.selectedOption)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.selectedOption[_ctx.displayBy]), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Выбрано неизвестное значение")
                          ], 64))
                    ], 64))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.placeholder), 1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_bs_loader, { key: 0 }))
          : (_openBlock(), _createElementBlock("svg", {
              key: 1,
              class: _normalizeClass(["icon__arrow", { 'arrow--rotated': _ctx.isVisible }]),
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, _hoisted_8, 2))
      ])
    ], 512),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "m-tooltip" }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createBlock(_component_bs_dropdown_tooltip, {
              key: 0,
              ref: "tooltip",
              position: _ctx.strategy,
              x: _ctx.x,
              y: _ctx.y
            }, {
              default: _withCtx(() => [
                (_ctx.searchable)
                  ? (_openBlock(), _createBlock(_component_bs_field, {
                      key: 0,
                      placeholder: "Поиск",
                      disabled: _ctx.disabled || _ctx.loading,
                      modelValue: _ctx.query,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event))
                    }, null, 8, ["disabled", "modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_options, {
                  value: _ctx.modelValue,
                  options: _ctx.filteredOptions,
                  "display-by": _ctx.displayBy,
                  "select-by": _ctx.selectBy,
                  "can-deselect": _ctx.canDeselect,
                  onUpdate: _ctx.onUpdate
                }, null, 8, ["value", "options", "display-by", "select-by", "can-deselect", "onUpdate"])
              ]),
              _: 1
            }, 8, ["position", "x", "y"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}